import React from "react";
import { BtnWithIconAndText } from "components/btns";
import { SectionTitle } from "components/items";

import ic_right from "image/ic_right.svg";
import makeTitle from "function/makeTitle.js";

const InfoText = (props) => {
	return (
		<div className="InfoText">
			<SectionTitle text={makeTitle(props.title)} />

			<p className="text">{Array.isArray(props.paragraph) ? props.paragraph.map((el, index) => <span key={index}>{el}</span>) : props.paragraph}</p>

			{props.btnText !== "" ? (
				<div className="wrap-btn">
					<BtnWithIconAndText to={props.link} hash={true} text={props.btnText} icon={ic_right} className="right" />
				</div>
			) : (
				""
			)}
		</div>
	);
};

export default InfoText;
